import React from 'react';
import Button from '@material-ui/core/Button';
import useFileFormatButtonStyles from './FileTypeButtonStyles';
import { ReactComponent as PdfFileIcon } from '../../../../assets/pdfFileIcon.svg';
import { ReactComponent as PptFileIcon } from '../../../../assets/pptFileIcon.svg';
import { FileTypes } from '../../ExportDashboardTypes';

type Props = {
  handleClick: (fileType: FileTypes) => void;
  type: FileTypes;
};

const FileTypesComponents: Record<FileTypes, JSX.Element> = {
  pdf: <PdfFileIcon />,
  pptx: <PptFileIcon />
};
const FileTypeButton = (props: Props) => {
  const { handleClick, type } = props;
  const buttonClasses = useFileFormatButtonStyles();
  const Icon = () => FileTypesComponents[type];
  return (
    <Button
      className={`${buttonClasses.button} ${buttonClasses[type]}`}
      onClick={() => {
        handleClick(type);
      }}
    >
      <Icon />
    </Button>
  );
};

export default FileTypeButton;
